import RpcService from 'helpers/RpcService';
import RpcTypes from 'constants/rpcTypes';
import { AnyObject } from '../types/Common';
import { Feature } from '../pages/features/types';

export const getList = (params: AnyObject) => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.Feature_List,
          payload: { ...params },
        },
      ],
      isCancelable: true,
    })
    .then((data) => ({ ...data, items: data.rows || [] }));
};

export const getFeatureById = async (id: string): Promise<Feature> => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.Feature_Get,
          payload: { id },
        },
      ],
      isCancelable: true,
    });
};

export const getMerchantsByFeature = async (
  featureId: string,
  params?: AnyObject
): Promise<any> => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.Feature_Merchant,
          payload: { featureId, ...params },
        },
      ],
      isCancelable: true,
    })
    .then((data) => ({ ...data, items: data.rows || [] }));
};

export const getProjectsByFeature = async (
  featureId: string,
  params?: AnyObject
): Promise<any> => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.Feature_Project,
          payload: { featureId, ...params },
        },
      ],
      isCancelable: true,
    })
    .then((data) => ({ ...data, items: data.rows || [] }));
};

export const getUsersByFeature = async (
  featureId: string,
  params?: AnyObject
): Promise<any> => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.Feature_User,
          payload: { featureId, ...params },
        },
      ],
      isCancelable: true,
    })
    .then((data) => ({ ...data, items: data.rows || [] }));
};

export default {
  getList,
  getMerchantsByFeature,
  getProjectsByFeature,
  getUsersByFeature,
};
